import type { RouteIdType } from './routes';
import { RouteId } from './routes';

const memberHomeRoutes = new Set<string>([
  RouteId.MEMBER_HOME_WORKSPACE_BOARDS,
]);

export const isMemberHomeRoute = (routeId: RouteIdType): boolean =>
  memberHomeRoutes.has(routeId);
